module.exports = __webpack_public_path__ + "static/media/msmarking.bb4dabf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/Logos_Lieferanten/msmarking.png
// module id = 462
// module chunks = 0